"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    ONBOARDING: 'onboarding',
    ACTIVE: 'active',
    CLOSE_OUT: 'close_out',
    PAUSED_SERVICE_PAUSE: 'paused_service_pause',
    PAUSED_OUTSTANDING_PAYMENTS: 'paused_outstanding_payments',
    ALUMNI: 'alumni',
    NON_ALUMNI: 'non-alumni',
    CANCELLED: 'cancelled',
};
//# sourceMappingURL=studentContractSubStatus.js.map